<template>
  <div class="retrieveList">
    <div class="retrieveList_title">
      <i class="el-icon-tickets"></i> 常规检索&nbsp; / &nbsp;<span
        style="color: #92959b"
        >检索结果</span
      >
    </div>
    <div>
      <el-card class="box-card">
        <!--<div class="clearfix">
          <div class="screen"><i class="el-icon-d-caret"></i>筛选</div>
          <div class="screen_button">
            <div class="screen_type">
              专利类型：
              <el-button size="mini">发明</el-button>
              <el-button size="mini">实用新型</el-button>
              <el-button size="mini">外观设计</el-button>
            </div>
            <div>
              有效专利：
              <el-button size="mini">有效</el-button>
              <el-button size="mini">无效</el-button>
            </div>
          </div>
        </div>-->
        <div class="clearfix1">
          <el-form ref="form" :model="form" label-width="70px">
            <el-row>
              <el-col :span="8">
                <el-form-item label="申请日：">
                  <el-date-picker
                    size="mini"
                    v-model="form.applicationStartTime"
                    type="date"
                    placeholder="开始日期"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                  -
                  <el-date-picker
                    size="mini"
                    v-model="form.applicationEndTime"
                    type="date"
                    placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="公开日:">
                  <el-date-picker
                    size="mini"
                    v-model="form.publicityStartTime"
                    type="date"
                    placeholder="开始日期"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                  -
                  <el-date-picker
                    size="mini"
                    v-model="form.publicityEndTime"
                    type="date"
                    placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="授权日：">
                  <el-date-picker
                    size="mini"
                    v-model="form.accreditStartTime"
                    type="date"
                    placeholder="开始日期"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                  -
                  <el-date-picker
                    size="mini"
                    v-model="form.accreditEndTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="clearfix2">
          <el-button icon="el-icon-search" class="btnok" @click="btnOk"
            >确定</el-button
          >
          <el-button
            icon="el-icon-refresh-right"
            class="clear"
            @click="handleFn"
            >重置</el-button
          >
        </div>
      </el-card>
      <div>
        <el-card>
          <div class="first_table">
            <el-table
              ref="table"
              :cell-class-name="cellclassname"
              :data="result"
              :header-cell-style="{ background: '#f7f7f7' }"
              :span-method="arraySpanMethod"
            >
              <el-table-column align="center" type="selection" width="55">
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                prop="openNum"
                label="公开号"
                :fixed="true"
              >
                <template slot-scope="scope">
                  <div v-if="scope.$index % 2 != 0" class="rowHeight">
                    <div>
                      <el-image
                        class="el_image"
                        :src="scope.row.imgPath"
                        :preview-src-list="scope.row.imgurl"
                        fit="fit"
                      >
                      </el-image>
                    </div>
                    <div>
                      <el-button
                        class="xiangqin"
                        @click="datailsFn(scope.row.id)"
                        icon="el-icon-notebook-2"
                        >详情</el-button
                      >
                    </div>
                  </div>
                  <div v-else class="columnColor">
                    {{ scope.row.openNum }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="applicationNum"
                label="申请号"
              >
                <template slot-scope="scope">
                  <div v-if="scope.$index % 2 != 0" class="rowHeight">
                    <el-tabs
                      v-model="activeName2"
                      type="card"
                      :key="scope.$index"
                    >
                      <el-tab-pane
                        v-for="(item, index) in tabsList"
                        :label="item.label"
                        :name="`${scope.$index}_${item.name}`"
                        :key="index"
                        >{{ item.value }}</el-tab-pane
                      >
                    </el-tabs>
                  </div>
                  <div v-else>
                    {{ scope.row.applicationNum }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                prop="applicationTime"
                label="申请日"
              >
                <template slot-scope="scope">
                  <div class="columnColor">
                    {{ scope.row.applicationTime }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="titleInvention"
                label="发明名称"
              ></el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                prop="applicant"
                label="申请人"
              >
                <template slot-scope="scope">
                  <div class="columnColor">
                    {{ scope.row.applicant }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="pageination" id="pageination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 50, 100, 500]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
              >
              </el-pagination>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/util/request'
export default {
  data() {
    return {
      isVisable: false,
      value1: '',
      form: {
        applicationStartTime: '', //申请日
        applicationEndTime: '',
        publicityStartTime: '', //公开日
        publicityEndTime: '',
        accreditStartTime: '', //授权日
        accreditEndTime: '',
      },
      isAllSelected: false,
      isIndeterminate: false,
      activeName: 'first',
      activeName2: '1_One',
      currentPage1: 5,
      currentPage2: 5,
      currentPage3: 5,
      searchList: [],
      result: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      tablelist: [
        {
          publicationNumber: 'CN16634290A',
          applicationNumber: 'CN202310912384.3',
          applicationTime: '2023.07.25',
          name: '一种基于门控CMOS选通成像系统的图像融合方法及装置',
          applicationPerson: '苏州洞悉科技有限公司',
        },
        {
          imgurl: [
            'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
          ],
          publicationNumber: 'CN16634290A',
          applicationNumber: 'CN202310912384.3',
          applicationTime: '2023.07.25',
          name: '一种基于门控CMOS选通成像系统的图像融合方法及装置',
          applicationPerson: '苏州洞悉科技有限公司',
        },
        {
          publicationNumber: 'CN16634290A',
          applicationNumber: 'CN202310912384.3',
          applicationTime: '2023.07.25',
          name: '一种基于门控CMOS选通成像系统的图像融合方法及装置',
          applicationPerson: '苏州洞悉科技有限公司',
        },
        {
          imgurl: [
            'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
          ],
          publicationNumber: 'CN16634290A',
          applicationNumber: 'CN202310912384.3',
          applicationTime: '2023.07.25',
          name: '一种基于门控CMOS选通成像系统的图像融合方法及装置',
          applicationPerson: '苏州洞悉科技有限公司',
        },
      ],
      tabsList: [
        {
          label: '摘要',
          value: '',
          name: 'One',
        },
        {
          label: '主权利要求',
          value: '',
          name: 'two',
        },
        {
          label: '著录项目',
          value: '',
          name: 'Three',
        },
        {
          label: 'IPC分类',
          value: '',
          name: 'Four',
        },
        {
          label: 'CPC分类',
          value: '',
          name: 'Five',
        },
        {
          label: '法律状态',
          value: '',
          name: 'six',
        },
        {
          label: '同族',
          value: '',
          name: 'seven',
        },
        {
          label: '引证',
          value: '',
          name: 'eight',
        },
        {
          label: '被引证',
          value: '',
          name: 'nine',
        },
      ],
      tabbarBoxFixed: false,
      searchFormData: [],
    }
  },
  created() {
    this.searchList = JSON.parse(this.$route.query.searchList)
    this.searchFormData = JSON.parse(this.$route.query.searchFormData)
    console.log(this.searchList)
    console.log(this.searchFormData)
    this.getData()
  },
  mounted() {
    // 监听页面滚动事件
    window.addEventListener('scroll', this.scrolling)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrolling)
  },
  methods: {
    btnOk() {
      request({
        url: '/api/client/common/patent/search',
        method: 'get',
        params: {
          applicationDateStart: this.form.applicationStartTime,
          applicationDateEnd: this.form.applicationEndTime,
          publishDateStart: this.form.publicityStartTime,
          publishDateEnd: this.form.publicityEndTime,
          authAnnouncementStart: this.form.accreditStartTime,
          authAnnouncementEnd: this.form.accreditEndTime,
          applicant: this.searchFormData.inventor, //申请人
          applicationNum: this.searchFormData.applicationNumber, //申请号
          openNum: this.searchFormData.publicationNumber, //公开号
          patentNo: this.searchFormData.patentNumber, //专利号
          inventor: this.searchFormData.applicantName, //发明人
          patentName: this.searchFormData.searchName, //专利名称
          total: 10,
        },
      }).then((res) => {
        this.searchList = res.data
        this.getData()
      })
    },
    getData() {
      this.result = this.searchList.rows.flatMap((obj) => [obj, { ...obj }])
      this.total = this.searchList.total
      for (
        let i = 0;
        i < this.searchList.rows.length && i < this.tabsList.length;
        i++
      ) {
        // 赋值给其他对象的value属性
        for (let j = 0; j < this.tabsList.length; j++) {
          if (this.tabsList[i].label == '摘要')
            this.tabsList[i].value = this.result[i].abstracts
          if (this.tabsList[i].label == '主权利要求')
            this.tabsList[i].value = this.result[i].sovereigntyRequirements
          if (this.tabsList[i].label == '著录项目')
            this.tabsList[i].value = this.result[i].bibliographicItems
          if (this.tabsList[i].label == 'IPC分类')
            this.tabsList[i].value = this.result[i].ipc
          if (this.tabsList[i].label == 'CPC分类')
            this.tabsList[i].value = this.result[i].cpc
          if (this.tabsList[i].label == '法律状态')
            this.tabsList[i].value = this.result[i].lawStatus
          if (this.tabsList[i].label == '同族')
            this.tabsList[i].value = this.result[i].cognate
          if (this.tabsList[i].label == '引证')
            this.tabsList[i].value = this.result[i].quote
          if (this.tabsList[i].label == '被引证')
            this.tabsList[i].value = this.result[i].cited
        }
      }
    },
    handleFn() {
      this.form = {
        applicationStartTime: '',
        applicationEndTime: '',
        publicityStartTime: '',
        publicityEndTime: '',
        accreditStartTime: '',
        accreditEndTime: '',
      }
      this.btnOk()
    },
    datailsFn(id) {
      this.$router.push({
        path: '/details',
        query: {
          id: id,
        },
      })
    },
    handleSelectAllChange(val) {
      debugger

      this.isIndeterminate = false
      if (val) {
        // 选中所有行
        this.$refs.table.toggleAllSelection()
      } else {
        // 取消选中所有行
        this.$refs.table.clearSelection()
      }
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      // console.log(row, column)
      if (rowIndex % 2 != 0) {
        if (columnIndex === 2) {
          return [1, 4]
        }
      }
    },
    cellclassname(row, column, rowIndex, columnIndex) {
      if (rowIndex % 2 == 0) {
        if (columnIndex == 0 || columnIndex == 2) {
          return 'columnColor'
        }
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.pageNo = val
      this.getData()
    },

    scrolling() {
      // 滚动条距文档顶部的距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      // 滚动条滚动的距离
      let scrollStep = scrollTop - this.oldScrollTop
      console.log('header 滚动距离 ', scrollTop)
      // 更新——滚动前，滚动条距文档顶部的距离
      this.oldScrollTop = scrollTop

      //变量windowHeight是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight
      //变量scrollHeight是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight

      //滚动条到底部的条件
      if (scrollTop + windowHeight == scrollHeight) {
        //你想做的事情
        console.log('header  你已经到底部了')
      }
      if (scrollStep < 0) {
        console.log('header 滚动条向上滚动了！')
      } else {
        console.log('header  滚动条向下滚动了！')
      }
      // 判断是否到了最顶部
      if (scrollTop <= 0) {
        console.log('header 到了最顶部')
      }
    },
  },
}
</script>

<style scoped>
@import '../styles/retrieveList.css';
.retrieveList {
  margin: 10px 120px;
}
body,
html {
  width: 100% !important;
  min-height: 100vh !important;
}
.screen {
  margin-bottom: 10px;
}

.clearfix1 {
  border-bottom: 1px solid #eceef2;
}
.first_table {
  height: 100%;
}
::v-deep .el-table__header-wrapper {
  position: sticky; /* 设置表头为粘性定位 */
  top: 0; /* 固定表头位置在顶部 */
}
.box-card {
  margin-bottom: 20px;
}
.rowHeight {
  height: 300px !important;
}
.el_image {
  width: 300px;
  height: 256px;
  margin-bottom: -4px;
  border: 1px solid #ccc;
}
.retrieveList_title {
  font-size: 20px;
  font-weight: bold;
  align-items: center;
  display: flex;
  color: #353233;
  margin-bottom: 10px;
}
.clearfix {
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eceef2;
}
.screen_type {
  margin-right: 20px;
}
.el-icon-tickets:before {
  font-size: 27px;
}
.screen_button {
  display: flex;
}
::v-deep .el-button {
  background: #f0f7ff;
  border: 0;
  color: #4f6ed2;
}
::v-deep .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 145px;
}
.btnok {
  background: #3864d1;
  color: #fff;
  width: 100px;
}
.clearfix2 {
  display: flex;
  margin-top: 15px;
  justify-content: center;
}
.clear {
  width: 100px;
  color: #000;
  background: transparent;
  border: 1px solid #ccc;
}
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border-bottom: 1px solid #e4e7ed;
  background-color: #f0f2f5;
  border-radius: 0;
}
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
  /* border-left: 0; */
}
::v-deep .el-tabs--card > .el-tabs__header {
  border-bottom: 0;
}
::v-deep .el-tabs__item.is-active {
  background-color: #fff;
  color: #3864d1;
}
li {
  list-style-type: none;
}
ul {
  padding: 0;
}
::v-deep .el-table .cell {
  line-height: 27px;
}
::v-deep .el-tabs__content {
  line-height: 25px;
  text-align: left;
}
.pageination {
  display: flex;
  justify-content: center;
  z-index: 999;
  height: 50px;
  background: #fff;
  width: 83.15%;
  margin: 0px 121px;
  align-items: center;
}
.xiangqin {
  border: 1px solid #ccc;
  border-radius: 0;
  background-color: transparent;
  color: #353233;
  height: 35px;
  line-height: 12px;
  padding: 0 10px;
}
</style>
